import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
import { getExtension, convertToDateFormat } from '../../../helpers/helper';
import LicenseService from '../../../services/LicenseService/LicenseService';
import VersionService from '../../../services/VersionService/VersionService';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, personalizationState } from '../../../recoil-store/recoil-state';
import './LicenseAbout.css';
import { Link } from 'react-router-dom';
/**
 * @Description This function lets you return License and About Details dialog component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */

function LicenseAbout(props) {
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);
    const labell = 'CONTENT.LICENSE.';
    const labela = 'CONTENT.ABOUT.';
    const [license, setLicense] = useState({});
    const [about, setAbout] = useState({});
    const [file, setFile] = useState();
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        fetchData().then(r => r);
    }, []);

    const fetchData = async () => {
        let res = await LicenseService.getLicenseDetail();
        if (res?.status === true) {
            setLicense(res.data);
        } else if (res?.status === false) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LICENSE." + res.message),
                severity: 'error'
            }));
        }
        res = await VersionService.getAbout();
        if (res?.data) {
            setAbout(res.data);
        }
    }

    const handleInputChange = (event) => {
        if (event.target.files[0]?.name) {
            let extension = getExtension(event.target.files[0]?.name);
            if (extension === 'xml') {
                setFile(event.target.files[0]);
            } else {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('MESSAGES.LICENSE.LICENSE-XML-FORMAT'),
                    severity: 'error'
                }));
            }
        }
    };

    const handleSubmit = async () => {
        if (!file) {
            return;
        }
        const response = await LicenseService.addNewLicense(file);
        if (response) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('MESSAGES.LICENSE.' + response.message),
                severity: response.status ? 'success' : 'error'
            }));
            if (response.status) {
                await fetchData();
                window.location.reload();
            }
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }));
        }
    };

    const handleClose = () => {
        props.setOpen(false);
    };
    const handleClick = (e) => {
        props.setOpen(e.target.value);
    }
    return (
        <Dialog className="user-detail-dialog" onClose={handleClose} open={true} maxWidth="lg">
            <div className="db-tabs db-page">
                <button className={props.open === 'license' ? 'db-tabactive' : ''} value="license"
                    onClick={handleClick}>
                    {t('CONTENT.HELP-SECTIONS.LICENSE')}
                </button>
                <button className={props.open === 'about' ? 'db-tabactive' : ''} value="about" onClick={handleClick}>
                    {t('CONTENT.HELP-SECTIONS.ABOUT')}
                </button>
            </div>
            {props.open === 'license' ? <>
                <div className="about-details">
                    <div>
                        <div className="bot-desc-label">{t(labell + 'COMPANY-NAME')}</div>
                        <div className="bot-desc-info">{license.company_name}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labell + 'LICENSE-TYPE')}</div>
                        <div className="bot-desc-info">{license.type}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labela + 'LICENSE-NUMBER')}</div>
                        <div className="bot-desc-info">{license.key}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labell + 'NUMBER-RPA')}</div>
                        <div className="bot-desc-info">{license.no_of_rpa_bots}</div>
                    </div>
                    {/* <div>
                        <div className="bot-desc-label">{t(labell + 'ADD-ONS')}</div>
                        <div className="bot-desc-info">{license?.add_ons && license?.add_ons.join(', ')}</div>
                    </div> */}
                    {/* <div>
                        <div className="bot-desc-label">{t(labell + 'ACTION-LIMIT')}</div>
                        <div className="bot-desc-info">{license.action_limit}</div>
                    </div> */}
                    <div>
                        <div className="bot-desc-label">{t(labela + 'E-MAIL')}</div>
                        <div className="bot-desc-info">{license.email}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labell + 'EXPIRE-DATE')}</div>
                        <div
                            className="bot-desc-info">{license.expire_date && convertToDateFormat(license.expire_date, personalization.date_format, false)}</div>
                    </div>
                </div>
                <div className="about-footer-button">
                    {file ? <>
                        <div className="custom-file">
                            <input type="file" className="custom-file-input" accept=".xml" id="license-customFile"
                                onChange={handleInputChange} />
                            <label className="custom-file-label"
                                htmlFor="license-customFile">{file?.name ? file.name : t('CONTENT.SETTINGS.GENERAL.CHOOSE')}</label>
                        </div>
                        <button className="sgeneral-save" onClick={handleSubmit}>{t('CONTENT.ROLE.SAVE')}</button>
                    </> :
                        <label className="activate-license sgeneral-save">{t(labell + 'ACTIVATE')}
                            <input type="file" accept=".xml" onChange={handleInputChange} />
                        </label>
                    }
                </div>
            </> : <>
                <div className="about-details about">
                    <div>
                        <div className="bot-desc-label">{t(labela + 'LICENSE-TYPE')}</div>
                        <div className="bot-desc-info">{about.license_type}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labela + 'CONTACT-US')}</div>
                        <div className="bot-desc-info">
                            <Link to={about.name}>{about.name}</Link>
                        </div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labela + 'LICENSE-NUMBER')}</div>
                        <div className="bot-desc-info">{about.license_number}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labela + 'E-MAIL')}</div>
                        <div className="bot-desc-info">{about.contact_email}</div>
                    </div>
                    <div>
                        <div className="bot-desc-label">{t(labela + 'YOUR-VERSION')}</div>
                        <div className="bot-desc-info">{about.version}</div>
                    </div>
                </div>
                <div className="about-footer-button">
                    <button className="sgeneral-save" disabled>{t(labell + 'UPDATE')}</button>
                </div>
            </>
            }
            <div className="about-footer">
                <div id="about-footer" />
                <div className="bot-desc-label">{t(labell + 'COPYRIGHT')}</div>
            </div>
        </Dialog>
    );
}

export default LicenseAbout;
